"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useSubtitlesTrackList = void 0;
var React = __importStar(require("react"));
var video_context_1 = require("../context/video-context");
var react_1 = require("@xstate/react");
var selectors_1 = require("../selectors");
var use_player_prefs_1 = require("./use-player-prefs");
var find_1 = __importDefault(require("lodash/find"));
var useSubtitlesTrackList = function () {
    var videoService = (0, video_context_1.useVideo)();
    var textTracks = (0, react_1.useSelector)(videoService, selectors_1.selectTextTracks);
    var subtitles = Array.from(textTracks || []).filter(function (track) {
        return ['subtitles'].includes(track.kind);
    });
    var activateSubtitlesTrack = function (track) {
        videoService.send({ type: 'ACTIVATE_SUBTITLES_TRACK', track: track });
    };
    var clearSubtitlesTracks = function () {
        videoService.send({ type: 'CLEAR_SUBTITLES_TRACKS' });
    };
    /**
     * Get subtitle preference from cookie and activate it
     */
    var language = (0, use_player_prefs_1.getPlayerPrefs)().subtitle.language;
    React.useEffect(function () {
        var currentSubtitles = textTracks && (0, find_1["default"])(subtitles, function (track) { return (track === null || track === void 0 ? void 0 : track.language) === language; });
        currentSubtitles && activateSubtitlesTrack(currentSubtitles);
    }, [textTracks, subtitles]);
    return {
        subtitles: subtitles,
        activateSubtitlesTrack: activateSubtitlesTrack,
        clearSubtitlesTracks: clearSubtitlesTracks
    };
};
exports.useSubtitlesTrackList = useSubtitlesTrackList;
